import { render } from "./WheelTicketDetails.vue?vue&type=template&id=9ea17f9c"
import script from "./WheelTicketDetails.vue?vue&type=script&lang=js"
export * from "./WheelTicketDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__